import authsession from './authsession';

const deleteUserFun = ( api, sendData, notifyError, notifyInfo, notifySuccess, setModal, setDetailsWindow, dispatch, getUsers ) => {

    api({
        method: 'post',
        headers: { 'Authorization': authsession() },
        url: 'usersc.php?fun=delete&lokacija=dash',
        data: sendData,
    })
        .then((response) => {

            if (response.data.uspesno) {
                notifySuccess(response.data.uspesno);
                dispatch(getUsers());
                setModal(false);
                setDetailsWindow(false)
            } else if (response.data.greska) {
                notifyError(response.data.greska);

            } else if (response.data.info) {
                notifyInfo(response.data.info);
            }
        })
}

export default deleteUserFun